module.exports = __webpack_public_path__ + "media/images/brands/lilica_ripilica_page-90f23dbaab26dddb3555ef89cb8aadd9.png";